// extracted by mini-css-extract-plugin
module.exports = {"Content":"Square_Content__1tH-P","Square":"Square_Square__3kX6S"};